const ColorsDefault = {
	levelColors: {
		4: "rgb(139, 0, 0)",
		3: "rgb(255, 103, 0)",
		2: "rgb(255, 192, 0)",
		1: "rgb(255, 255, 153)",
		0: "rgb(255, 255, 255)",
		999: "rgba(230, 230, 230, 0.8)",
		plain: "rgba(255, 255, 255, 0.5)"
	},
    pctlColors: [
		{ color: "#b30000", range: [-1, 2] },
		{ color: "#ff6600", range: [2, 10] },
		{ color: "#ffc000", range: [10, 20] },
		{ color: "#ffff99", range: [20, 30] },
		{ color: "#66ff66", range: [30, 70] },
		{ color: "#8acdff", range: [70, 80] },
		{ color: "#569ad0", range: [80, 90] },
		{ color: "#1c669d", range: [90, 98] },
		{ color: "#6800b3", range: [98, 100] },
		{ color: "lightgray", range: [-1000,1000] }
    ],
	kbdiColors: [
		{ color: "#b30000", range: [ 700, 801] },
		{ color: "#ff6600", range: [ 600, 700] },
		{ color: "#ffc000", range: [ 400, 600] },
		{ color: "#ffff99", range: [ 200, 400] },
		{ color: "#66ff66", range: [   0, 200] },
		{ color: "lightgray", range: [-1000,1000] }
    ]
};

//changes made to pctlColors may also need to be applied to the legend icons in maps.css

export default ColorsDefault;